class MainHeader {
	header: HTMLDivElement | null;
	adminBar: HTMLElement | null;

	constructor() {
		this.header = document.querySelector<HTMLDivElement>('.main-header');
		this.adminBar = document.getElementById('wpadminbar');
	}

	init() {
		this.setHeaderHeight();
	}

	resized() {
		this.setHeaderHeight();
	}

	loaded() {
		this.setHeaderHeight();
	}

	setHeaderHeight() {
		if (!this.header) return;

		const headerHeight = this.header.offsetHeight;
		let headerHeightFull = this.header.offsetHeight;

		if (null !== this.adminBar) {
			headerHeightFull += this.adminBar.offsetHeight;
		}

		document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
		document.documentElement.style.setProperty('--headerHeight', headerHeight + 'px');
		document.documentElement.style.setProperty('--headerHeightFull', headerHeightFull + 'px');
	}
}

export default new MainHeader();
